export default function LockIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9.5 1.125C10.0967 1.125 10.669 1.36205 11.091 1.78401C11.5129 2.20597 11.75 2.77826 11.75 3.375V7.875H7.25V3.375C7.25 2.77826 7.48705 2.20597 7.90901 1.78401C8.33097 1.36205 8.90326 1.125 9.5 1.125ZM12.875 7.875V3.375C12.875 2.47989 12.5194 1.62145 11.8865 0.988515C11.2536 0.355579 10.3951 0 9.5 0C8.60489 0 7.74645 0.355579 7.11351 0.988515C6.48058 1.62145 6.125 2.47989 6.125 3.375V7.875C5.52826 7.875 4.95597 8.11205 4.53401 8.53401C4.11205 8.95597 3.875 9.52826 3.875 10.125V15.75C3.875 16.3467 4.11205 16.919 4.53401 17.341C4.95597 17.7629 5.52826 18 6.125 18H12.875C13.4717 18 14.044 17.7629 14.466 17.341C14.8879 16.919 15.125 16.3467 15.125 15.75V10.125C15.125 9.52826 14.8879 8.95597 14.466 8.53401C14.044 8.11205 13.4717 7.875 12.875 7.875Z"
        fill="#AFBACA"
      />
    </svg>
  );
}
